import { Instance } from 'mobx-state-tree';
import { SupportSessionDtoModelBase } from './SupportSessionDtoModel.base';

/* The TypeScript type of an instance of SupportSessionDtoModel */
export interface SupportSessionDtoModelType extends Instance<typeof SupportSessionDtoModel.Type> {}

/* A graphql query fragment builders for SupportSessionDtoModel */
export { selectFromSupportSessionDto, supportSessionDtoModelPrimitives, SupportSessionDtoModelSelector } from './SupportSessionDtoModel.base';

/**
 * SupportSessionDtoModel
 */
export const SupportSessionDtoModel = SupportSessionDtoModelBase
  .actions(self => ({
    // This is an auto-generated example action.
    log() {
      console.log(JSON.stringify(self));
    },
  }));
